import { createContext, useContext } from 'react';

/**
 * 🔒 Whether the list pane stands open beside the record this frame draws (T3685; decision 11540). The list-and-detail
 * frame provides it around its record; a record drawn anywhere else reads false. A document reads it to stand its
 * notes rail under the sheet below `documentRailBeside`, so the sheet keeps a readable column while the list stays.
 */
export const ListPaneOpenContext = createContext(false);

/** The list pane's state as the record beside it reads it. */
export function useListPaneOpen(): boolean {
  return useContext(ListPaneOpenContext);
}
